import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import BASE_URL from "../auth/Baseurl";
import Swal from "sweetalert2";
import { ThemeContext } from "../../context/ContextFile";

const SearchModal = ({ filters, setFilters }) => {
  const [facility, setFacility] = useState([]);
  const [amenity, setAmenity] = useState([]);
  let { SetTheme } = useContext(ThemeContext);
  const GetData1 = () => {
    axios
      .get(`${BASE_URL}/facility`, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((res) => {
        // console.log(res.data?.data, "values");
        setFacility(res.data?.data || []);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const GetData2 = () => {
    axios
      .get(`${BASE_URL}/amenity`, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((res) => {
        setAmenity(res.data?.data || []); // Ensure amenity is always an array
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    GetData1();
    GetData2();
  }, []);

  const [formData, setFormData] = useState({
    byTypeOfSpace: "",
    byMin: "",
    byMax: "",
    byNoOfBedroom: "",
    byNoOfRoom: "",
    amenity: [],
    facility: [],
  });

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    const inputValue = type === "checkbox" ? (checked ? 1 : 0) : value;
    setFormData((prevState) => ({
      ...prevState,
      [name]: inputValue,
    }));
  };

  const valueGetFacilities = (e) => {
    const { name, checked } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      facility: checked
        ? [...prevState.facility, name] // Add facility if checked
        : prevState.facility.filter((item) => item !== name), // Remove facility if unchecked
    }));
  };
  const valueGetAmenities = (e) => {
    const { name, checked } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      amenity: checked
        ? [...prevState.amenity, name]
        : prevState.amenity.filter((item) => item !== name),
    }));
  };

  const value = new FormData();
  value.append("byTypeOfSpace", formData.byTypeOfSpace);
  value.append("byMin", formData.byMin);
  value.append("byMax", formData.byMax);
  value.append("byNoOfBedroom", formData.byNoOfBedroom);
  value.append("byNoOfRoom", formData.byNoOfRoom);
  value.append("amenity", JSON.stringify(formData.amenity));
  value.append("facility", JSON.stringify(formData.facility));

  const isFormValid = () => {
    return (
      formData.byTypeOfSpace ||
      formData.byMin ||
      formData.byMax ||
      formData.byNoOfBedroom ||
      formData.byNoOfRoom ||
      formData.amenity ||
      formData.facility
    );
  };
  const GetData = () => {
    if (!isFormValid()) {
      console.log("Please fill out all required fields.");
      return;
    }

    axios
      .post(`${BASE_URL}/listing-search`, value, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((res) => {
        SetTheme(res?.data);

        Swal.fire({
          position: "center",
          html: `
            <div style="display: flex; flex-direction: column; align-items: center;">
<svg
                      viewBox="0 0 1024 1024"
                      height="4em"
                      width="4em"
                      style="margin-bottom: 10px;"
                  >
                      <!-- Outer circle with color #8ec639 -->
                      <path fill="#8ec639" d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" />
                      
                      <!-- Check mark with color #A2c66b -->
                      <path fill="#A2c66b" d="M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0051.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z" />
                  </svg>
                <p style="margin: 0; font-size: 1.2em;">Profile update successful.</p>
            </div>
        `,
          title: res?.data?.message,
          showConfirmButton: true,
          timer: 1500,
        });
        setFilters(false);
      })

      .catch((err) => {
        SetTheme(err);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: err?.response?.data?.message,
        });
      });
  };
  console.log(formData, "formdata");
  return (
    <>
      {filters ? (
        <>
          <div
            className="modal fade show"
            id="gridSystemModal"
            tabIndex={-1}
            aria-labelledby="gridModalLabel"
            style={{ display: "block" }}
            aria-modal="true"
            role="dialog"
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-body">
                  <div className="container-fluid bd-example-row">
                    <div className="row">
                      <div className="col-md-3">
                        {" "}
                        <div className="dashboard-title  dt-inbox fl-wrap">
                          <h3>Size</h3>
                        </div>
                      </div>
                      <div className="col-md-3 ms-auto">
                        <div className="listsearch-input-item">
                          <select
                            data-placeholder="Apartments"
                            className="nice-select chosen-select no-search-select"
                            name="byNoOfBedroom"
                            value={formData.byNoOfBedroom}
                            onChange={handleInputChange}
                          >
                            <option>no of bedrooms</option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="6">6</option>
                            <option value="7">7</option>
                            <option value="8">8</option>
                            <option value="9">9</option>
                            <option value="10">10</option>
                            <option value="11">11</option>
                            <option value="12">12</option>
                            <option value="13">13</option>
                            <option value="14">14</option>
                            <option value="15">15</option>
                            <option value="16">16</option>
                            <option value="17">17</option>
                            <option value="18">18</option>
                            <option value="19">19</option>
                            <option value="20">20</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-3 ms-auto">
                        <div className="listsearch-input-item">
                          <select
                            data-placeholder="Apartments"
                            className="nice-select chosen-select no-search-select"
                            name="byNoOfRoom"
                            value={formData.byNoOfRoom}
                            onChange={handleInputChange}
                          >
                            <option>no of rooms</option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="6">6</option>
                            <option value="7">7</option>
                            <option value="8">8</option>
                            <option value="9">9</option>
                            <option value="10">10</option>
                            <option value="11">11</option>
                            <option value="12">12</option>
                            <option value="13">13</option>
                            <option value="14">14</option>
                            <option value="15">15</option>
                            <option value="16">16</option>
                            <option value="17">17</option>
                            <option value="18">18</option>
                            <option value="19">19</option>
                            <option value="20">20</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-3 ms-auto">
                        <div className="listsearch-input-item">
                          <select
                            data-placeholder="Apartments"
                            className="nice-select chosen-select no-search-select"
                            name="byTypeOfSpace"
                            value={formData.byTypeOfSpace}
                            onChange={handleInputChange}
                          >
                            <option value={"1"}>Space</option>

                            <option value={"Entire Place"}>Entire Place</option>
                            <option value={"Private Room"}>Private Room</option>
                            <option value={"Shared Room"}>Shared Room</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-3">
                        {" "}
                        <div className="dashboard-title  dt-inbox fl-wrap">
                          <h3>Price</h3>
                        </div>
                      </div>
                      <div className="col-md-3 ms-auto">
                        <div className="listsearch-input-item">
                          <select
                            data-placeholder="Apartments"
                            className="nice-select chosen-select no-search-select"
                            name="byMin"
                            value={formData.byMin}
                            onChange={handleInputChange}
                          >
                            <option>Min.</option>
                            <option value="10">$10</option>
                            <option value="20">$20</option>
                            <option value="30">$30</option>
                            <option value="40">$40</option>
                            <option value="60">$60</option>
                            <option value="70">$70</option>
                            <option value="80">$80</option>
                            <option value="90">$90</option>
                            <option value="100">$100</option>
                            <option value="110">$110</option>
                            <option value="120">$120</option>
                            <option value="130">$130</option>
                            <option value="140">$140</option>
                            <option value="150">$150</option>
                            <option value="160">$160</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-3 ms-auto">
                        <div className="listsearch-input-item">
                          <select
                            data-placeholder="Apartments"
                            className="nice-select chosen-select no-search-select"
                            name="byMax"
                            value={formData.byMax}
                            onChange={handleInputChange}
                          >
                            <option>Max.</option>
                            <option value="50">$50</option>
                            <option value="100">$100</option>
                            <option value="125">$125</option>
                            <option value="150">$150</option>
                            <option value="160">$160</option>
                            <option value="200">$200</option>
                            <option value="250">$250</option>
                            <option value="300">$300</option>
                            <option value="400">$400</option>
                            <option value="500">$500</option>
                            <option value="600">$600</option>
                            <option value="700">$700</option>
                            <option value="800">$800</option>
                            <option value="900">$900</option>
                            <option value="1000">$1000</option>
                            <option value="1200">$1200</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-3 ms-auto">
                        {" "}
                        <div className="dashboard-title  dt-inbox fl-wrap">
                          <h3>Facilities</h3>
                        </div>
                      </div>
                      <div className="col-md-9 ms-auto">
                        <div className="profile-edit-container fl-wrap block_box">
                          <div className="custom-form">
                            {/* Checkboxes */}
                            <ul className="fl-wrap filter-tags no-list-style ds-tg">
                              {facility.map((item, index) => (
                                <li key={index}>
                                  <input
                                    id={`check-${index}`}
                                    type="checkbox"
                                    name={item.name}
                                    defaultChecked=""
                                    onChange={valueGetFacilities}
                                  />
                                  <label htmlFor={`check-${index}`}>
                                    {item.name}
                                  </label>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-3 ms-auto">
                        {" "}
                        <div className="dashboard-title  dt-inbox fl-wrap">
                          <h3>Amenity</h3>
                        </div>
                      </div>
                      <div className="col-md-9 ms-auto">
                        <div className="profile-edit-container fl-wrap block_box">
                          <div className="custom-form">
                            {/* Checkboxes */}
                            <ul className="fl-wrap filter-tags no-list-style ds-tg">
                              {amenity.map((item, index) => (
                                <li key={index}>
                                  <input
                                    id={`check-${index}`}
                                    type="checkbox"
                                    name={item.name}
                                    defaultChecked=""
                                    onChange={valueGetAmenities}
                                  />
                                  <label htmlFor={`check-${index}`}>
                                    {item.name}
                                  </label>
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    onClick={() => setFilters(false)}
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                  <button
                    onClick={GetData}
                    type="button"
                    disabled={!isFormValid()}
                    className="btn btn-primary"
                  >
                    Filter
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : null}
    </>
  );
};

export default SearchModal;
